import { Notification } from "element-ui";
import { api } from "../../gateways/unilabApi";

export default {
  getUms(category) {
    return new Promise((resolve, reject) => {
      api
        .get(`um/categories/${category}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Notification.error({
            title: "Attenzione",
            message: error
          });
          reject(error);
        });
    });
  }
};
